import React from "react";
import { Box, Stack } from "@mui/material";
import { Bottombar } from "../../../components/Bottombar";
import { Navbar } from "../../../components/Navbar";
import { Announcements } from "../../../components/Announcements";
import { StudentDashboard } from "../../../components/StudentDashboard";

function Home() {

  return (
    <Box sx={{width: '100%', paddingBottom: '56px'}}>
      <Navbar />
      <Stack spacing={1} p='15px'>
        <StudentDashboard />
        <Announcements />
      </Stack>
      <Bottombar value={0} />
    </Box>
  );
}

export default Home;
